/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * ClientEventApi - axios parameter creator
 * @export
 */
export const ClientEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ホスト名やユーザーエージェント、操作内容、パス名などのクライアントから送られてきた情報を保存する
         * @summary ユーザーの操作内容などを記録する
         * @param {string} message 操作内容などの情報を含んだJSONをシリアライズした文字列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClientEvent: async (message: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('postClientEvent', 'message', message)
            const localVarPath = `/client-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (message !== undefined) { 
                localVarFormParams.set('message', message as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientEventApi - functional programming interface
 * @export
 */
export const ClientEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientEventApiAxiosParamCreator(configuration)
    return {
        /**
         * ホスト名やユーザーエージェント、操作内容、パス名などのクライアントから送られてきた情報を保存する
         * @summary ユーザーの操作内容などを記録する
         * @param {string} message 操作内容などの情報を含んだJSONをシリアライズした文字列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClientEvent(message: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClientEvent(message, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientEventApi - factory interface
 * @export
 */
export const ClientEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientEventApiFp(configuration)
    return {
        /**
         * ホスト名やユーザーエージェント、操作内容、パス名などのクライアントから送られてきた情報を保存する
         * @summary ユーザーの操作内容などを記録する
         * @param {string} message 操作内容などの情報を含んだJSONをシリアライズした文字列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClientEvent(message: string, options?: any): AxiosPromise<void> {
            return localVarFp.postClientEvent(message, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientEventApi - interface
 * @export
 * @interface ClientEventApi
 */
export interface ClientEventApiInterface {
    /**
     * ホスト名やユーザーエージェント、操作内容、パス名などのクライアントから送られてきた情報を保存する
     * @summary ユーザーの操作内容などを記録する
     * @param {string} message 操作内容などの情報を含んだJSONをシリアライズした文字列
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientEventApiInterface
     */
    postClientEvent(message: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ClientEventApi - object-oriented interface
 * @export
 * @class ClientEventApi
 * @extends {BaseAPI}
 */
export class ClientEventApi extends BaseAPI implements ClientEventApiInterface {
    /**
     * ホスト名やユーザーエージェント、操作内容、パス名などのクライアントから送られてきた情報を保存する
     * @summary ユーザーの操作内容などを記録する
     * @param {string} message 操作内容などの情報を含んだJSONをシリアライズした文字列
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientEventApi
     */
    public postClientEvent(message: string, options?: AxiosRequestConfig) {
        return ClientEventApiFp(this.configuration).postClientEvent(message, options).then((request) => request(this.axios, this.basePath));
    }
}
